import { render } from "./SlideGroup.vue?vue&type=template&id=0fa178ab&scoped=true"
import script from "./SlideGroup.vue?vue&type=script&lang=js"
export * from "./SlideGroup.vue?vue&type=script&lang=js"

import "./SlideGroup.vue?vue&type=style&index=0&id=0fa178ab&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa178ab"]])

export default __exports__